module.exports = __webpack_public_path__ + "static/media/notes-of-love-four.6ceece0d.png";